import React, { useEffect, useState } from 'react';

import './styles.scss';
import logoRectangle from './assets/hp-logo-black.svg';
import twitter from './assets/twitter.png';
import linkedin from './assets/linkedin.png';
import producthunt from './assets/producthunt.png';
import logoWhite from '../CompetitorsComparison/hp-white.svg';
import europe from './assets/europe.svg';
import { Helmet } from 'react-helmet'

const Footer = ({ darkMode = false }) => {
  return (
    <div className={`footer relative ${darkMode ? 'dark' : ''}`} style={{
      paddingTop: darkMode ? '3em' : '0em'
    }}>
      <div className="line-gradient" />
      <Helmet>
      <script type="text/javascript">
        {`window.badge_data = {
          "statuspage": "meta.hyperping.app",
          "border": "none",
          "borderColor": "#30363D",
          "uptime": false,
          "dot": true,
          "dotSize": 10,
          "isNeutral": false,
          "dotOk": "#2BAC76",
          "dotIncident": "#FFAF36",
          "dotOutage": "#E95858",
          "dotMaintenance": "#0070F3",
          "dotNeutral": "#0070F3",
          "operational": "All systems normal",
          "incident": "Under investigation",
          "outage": "System outage",
          "maintenance": "Under maintenance"
        }`}
      </script>
      <script src="/badge.js" async onload="Hyperping.init(window.badge_data)" />
      </Helmet>
      <div className="col-3">
        <div className="footer-header">
          {/* Hyperping */}
          {darkMode ? <img src={logoWhite} height="22px" /> : <img alt="small-company-logo" src={logoRectangle} height="22px" />}
        </div>
        <div className="footer-description">
          50 Avenue des Champs-Élysées<br/>
          75008 Paris, France
        </div>
      </div>
      <div className="col-3">
        <div className="footer-header" style={{paddingLeft:'8px'}}>Product</div>
        <a href="/uptime-monitoring" className="footer-item">Monitoring</a>
        <a href="/status-page" className="footer-item">Status Page</a>
        <a href="/synthetic-monitoring" className="footer-item">Synthetic monitoring</a>
        <a href="/cron-job-monitoring" className="footer-item">Cron job monitoring</a>
        {/* <a href="/incident-manager" className="footer-item">Incident Management</a> */}
        <a href="/ssl-monitoring" className="footer-item">SSL monitoring</a>
        <a href="/escalation-policies" className="footer-item">Escalation policies</a>
        <a href="/pricing" className="footer-item">Pricing</a>
        <a href="/changelog" className="footer-item">Changelog</a>
        <a href="/features" className="footer-item">Features</a>
        {/* <a href="https://share.hsforms.com/16n_mkAEwSuaoRHEFYOV_KA8nn6d" target="_blank" className="footer-item">Contact sales</a> */}
      </div>
      <div className="col-3">
        <div className="footer-header" style={{paddingLeft:'8px'}}>Resources</div>
        <a href="/blog" className="footer-item">Blog</a>
        <a href="/docs" className="footer-item">Docs</a>
        <a href="/about" className="footer-item">About us</a>
        <a href="/why" className="footer-item">Why Hyperping</a>
        <a href="https://hyperping.notion.site/Hyperping-API-documentation-a0dc48fb818e4542a8f7fb4163ede2c3" target="_blank" className="footer-item">API Reference</a>
        <a href="/customers" className="footer-item">Customers</a>
        <a href="/#enterprise" className="footer-item">Enterprise</a>
        <a href="/customers/showcase" className="footer-item">Status page examples</a>
        {/* <a href="/alternatives" className="footer-item">Alternatives</a>
        <a href="/pingdom-alternative" className="footer-item">Pingdom Alternative</a>
        <a href="/alternatives/statuspage-alternative-concurrent" className="footer-item">Statuspage Alternative</a>
        <a href="/alternatives/uptimerobot-alternative-concurrent" className="footer-item">UptimeRobot Alternative</a> */}
        <a href="/sla-calculator" className="footer-item">SLA calculator</a>
        <a href="/downtime-cost-calculator" className="footer-item">Downtime cost calculator</a>
        <a href="/cron-expression-generator" className="footer-item">Cron expression generator</a>
        <a href="/comparison-hub" className="footer-item">Compare</a>
        <a href="/badge-builder" className="footer-item">Badge builder</a>
      </div>
      {/* <div className="col-3">
        <div className="footer-header">Tools</div>
        <a href="/tools/ip-address" className="footer-item">What's my IP address</a>
      </div> */}
      <div className="col-3">
        <div className="footer-header" style={{paddingLeft:'8px'}}>Socials</div>
          <div className="footer-socials">
            <a href="https://twitter.com/hyperping" target="_blank" className="footer-social"><img alt="socials-twitter" src={twitter} width="18px" /></a>
            <a href="https://www.producthunt.com/posts/hyperping-2-0" target="_blank" className="footer-social"><img alt="socials-producthunt" src={producthunt} width="18px" /></a>
            {/* <a href="https://www.linkedin.com/company/hyperping" target="_blank" className="footer-social"><img alt="socials-linkedin" src={linkedin} width="18px" /></a> */}
          </div>
          <div className="footer-item not-hoverable">hello@hyperping.io</div>
          {/* <a href="https://yourdomain.hyperping.io" target="_blank" className="footer-item">
            <span className={`status-dot ${indicator}`} />
            <span>{status}</span>
          </a> */}
          <a className="footer-item" id="hyperping-badge"></a>
          <a href="/terms" className="footer-item">Terms of Service</a>
          <a href="/privacy" className="footer-item">Privacy Policy</a>
          <a href="/security" className="footer-item">Security & GDPR <img src={europe} height="22px" /></a>
      </div>
    </div>
  );
}

export default Footer
